import { Button, Card, Heading, Text } from "@/design-system";

type ToolResultCtaProps = {
  id: string;
  title: string;
  description: string;
  onDemo: () => void;
};

/**
 * Convite que fecha o resultado de uma ferramenta: o lojista acabou de ver o
 * problema em número, e a Fidexa aparece como quem resolve sem trabalho manual.
 */
export const ToolResultCta = ({
  id,
  title,
  description,
  onDemo,
}: ToolResultCtaProps) => (
  <Card className="bg-ds-ink-900 border-ds-ink-900 flex flex-col gap-4 md:flex-row md:items-center md:justify-between print:hidden">
    <div className="flex max-w-2xl flex-col gap-2">
      <Heading level={2} size={3} id={id} className="text-ds-on-solid">
        {title}
      </Heading>
      <Text className="text-ds-on-solid">{description}</Text>
    </div>
    <Button size="lg" className="shrink-0" onClick={onDemo}>
      Agendar demonstração gratuita
    </Button>
  </Card>
);
